/**
 * GlassCircleButton — Frosted glass circle button for gradient headers
 *
 * 36px visual circle on gradient backgrounds.
 * 44px touch target via padding.
 * Optional badge dot (red) for notification counts.
 */

import { T } from '@/styles/tokens';

interface GlassCircleButtonProps {
  icon: React.ReactNode;
  onClick?: () => void;
  badge?: number;
  ariaLabel: string;
}

export function GlassCircleButton({ icon, onClick, badge, ariaLabel }: GlassCircleButtonProps) {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: 18,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        // 44px touch target via min dimensions
        minWidth: 44,
        minHeight: 44,
      }}
    >
      {icon}
      {badge != null && badge > 0 && (
        <div
          style={{
            position: 'absolute',
            top: 2,
            right: 2,
            width: 10,
            height: 10,
            borderRadius: 5,
            background: '#E07A3D',
            border: '2px solid rgba(42,144,137,0.9)',
          }}
        />
      )}
    </button>
  );
}
